// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"504":"5a669983","808":"5a669983"}[chunkId] + ".chunk.css";
};